import React, {useImperativeHandle, useRef} from 'react';
import {Platform} from 'react-native';
import ComActionUpload from 'screens/MainScreen/DigitalSignature/ComActionUpload';
import {getImageCamera, getImageLibrary} from 'utils';
import Alert from './Alert';
import BottomSheetDialog from './BottomSheetDialog';
import Toast from './Toast';

const ComActionUploadFile = (p: {doAction: (t: any) => void}, ref) => {
  const bottomSheetUpload = useRef<any>(null);
  const {doAction} = p;
  useImperativeHandle(ref, () => ({
    show: () => {
      bottomSheetUpload.current.show();
    },
    hide: (cb?: () => void) => {
      if (bottomSheetUpload.current) {
        bottomSheetUpload.current.hide().then(() => {
          if (cb) {
            cb();
          }
        });
      }
    },
  }));

  const hide = (cb?: () => void) => {
    if (bottomSheetUpload.current) {
      bottomSheetUpload.current.hide().then(() => {
        if (cb) {
          cb();
        }
      });
    }
  };

  return (
    <BottomSheetDialog
      style={{
        flexDirection: 'column',
        flex: 1,
        alignItems: 'center',
        justifyContent: 'flex-end',
      }}
      ref={bottomSheetUpload}>
      <ComActionUpload
        onCancel={() => {
          hide();
        }}
        onCamera={async () => {
          try {
            if (Platform.OS === 'ios') {
              await getImageCamera()
                .then((image: any) => {
                  hide();
                  if (image[0]) {
                    doAction(image[0]);
                  }
                })
                .catch(() => {
                  hide();
                });
              return;
            }
            hide(async () => {
              getImageCamera()
                .then((image: any) => {
                  if (image[0]) {
                    doAction(image[0]);
                  }
                })
                .catch(() => {
                  hide();
                });
            });
          } catch (error) {
            if (!!error) {
              Toast.show({
                content: 'alert.daxayraloi',
                multilanguage: true,
              });
            }
          } finally {
            hide(async () => {});
          }
        }}
        onGallery={async () => {
          try {
            if (Platform.OS === 'ios') {
              await getImageLibrary().then((image: any) => {
                hide();
                if (image[0]) {
                  if (image[0].uri.endsWith('.gif')) {
                    Alert.showError({
                      content: 'alert.dinhdanganhkhongphuhop',
                    });
                    return;
                  }
                  doAction(image[0]);
                }
              });
              return;
            }
            hide(() => {
              getImageLibrary().then((image: any) => {
                if (image[0]) {
                  if (image[0].uri.endsWith('.gif')) {
                    Alert.showError({
                      content: 'alert.dinhdanganhkhongphuhop',
                    });
                    return;
                  }
                  doAction(image[0]);
                }
              });
            });
          } catch (error) {
            if (!!error) {
              Toast.show({
                content: 'alert.daxayraloi',
                multilanguage: true,
              });
              return;
            }
          } finally {
            hide(async () => {});
          }
        }}
      />
    </BottomSheetDialog>
  );
};

export default React.forwardRef(ComActionUploadFile);
